import React, { useEffect, useState } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserSwitchOutlined,
  DownOutlined,
  FileZipOutlined,
  UserOutlined,
  WhatsAppOutlined,
  CopyOutlined,
  CheckOutlined,
  DollarOutlined,
  GiftOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import {
  Layout,
  Menu,
  Button,
  theme,
  Dropdown,
  Space,
  Alert,
  Flex,
  message,
  Modal,
  Form,
  Input,
  Typography,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { LocalStorageService } from "../services/LocalStorage";
import { isLogin, setUserData } from "../Actions";
import AxiosService from "../services/APIService";
import sidebarlogosm from "../Assets/sidebarLogoSm.png";
import logolg from "../Assets/logo.svg";
import { handleWhatsAppClick } from "../commonFunction";
import AffiliateForm from "../Pages/affiliateForm";

const { Header, Sider, Content } = Layout;

const UserLayout = ({ children, user, isLogin, setUserData, customer }) => {
  const apiService = new AxiosService();
  const [collapsed, setCollapsed] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [affiliateState, setAffiliateState] = useState(null);
  const [copiedAffiliate, setCopiedAffiliate] = useState(false);
  const [copiedReferral, setCopiedReferral] = useState(false);
  const [isAffiliateFormOpen, setIsAffiliateFormOpen] = useState(false);
  const [form] = Form.useForm();
  const [toastShown, setToastShown] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const {
    token: { borderRadiusLG },
  } = theme.useToken();
  const userData = LocalStorageService.getItem("user");

  useEffect(() => {
    const token = LocalStorageService.getItem("userToken");
    if (token) {
      checkAuthentication();
    } else {
      isLogin(false);
      setUserData(null);
    }
  }, []);

  useEffect(() => {
    user?._id && affiliateStatus(user?._id);
  }, [user?._id]);

  const menuItems = [
    {
      key: "1",
      icon: <UserOutlined />,
      label: <Link to={`/dashboard`}>Dashboard</Link>,
    },
    {
      key: "5",
      icon: <DollarOutlined />,
      label: <Link to={`/commission`}>Commission</Link>,
    },
    {
      key: "6",
      icon: <ShoppingCartOutlined />,
      label: <Link to={`/my-purchase`}>My Purchase</Link>,
    },
    {
      key: "4",
      icon: <GiftOutlined />,
      label: <Link to={`/promocode`}>Affiliate Promocode</Link>,
    },
    {
      key: "2",
      icon: <UserSwitchOutlined />,
      label: <Link to={`/profile`}>My Profile</Link>,
    },
    {
      key: "3",
      icon: <FileZipOutlined />,
      label: <Link to={`/notes`}>Notes</Link>,
    },
  ];

  const items = [
    {
      label: "Logout",
      key: "0",
    },
    {
      label: "Change Password",
      key: "1",
    },
  ];

  const menuClick = (val) => {
    switch (val.key) {
      case "0":
        logoutHandle();
        break;
      case "1":
        setIsModalOpen(true);
        break;
      default:
        break;
    }
  };

  const logoutHandle = () => {
    LocalStorageService.removeItem("userToken");
    LocalStorageService.removeItem("user");
    setUserData(null);
    isLogin(false);
    navigate("/");
  };

  const checkAuthentication = async () => {
    apiService
      .get("/auth/me")
      .then((res) => {
        setUserData(res.user);
      })
      .catch((e) => {
        message.error(e.message || "Something went wrong");
      });
  };

  const createAffiliate = async (userId, socialMedia = {}) => {
    try {
      const res = await apiService.post("affiliate/create", {
        userId,
        socialMedia,
      });

      if (res.success) {
        if (!toastShown) {
          message.success(res.message || "Affiliate created successfully");
          setToastShown(true);
        }

        setUserData((prev) => ({
          ...prev,
          affiliateCode: res.payload.affiliateCode,
        }));
        setAffiliateState(res.payload.affiliateStatus);

        const updatedUser = {
          ...userData,
          affiliateCode: res.payload.affiliateCode,
          socialMedia: res.payload.socialMedia,
        };

        localStorage.setItem("user", JSON.stringify(updatedUser));
      } else {
        if (!toastShown) {
          message.error(res.message || "Failed to create affiliate");
          setToastShown(true);
        }
      }
    } catch (error) {
      if (!toastShown) {
        message.error(error.message || "Something went wrong");
        setToastShown(true);
      }
    }
  };

  const affiliateStatus = async (userId) => {
    apiService
      .get(`affiliate/user/${userId}/affiliate-status`)
      .then((res) => {
        setAffiliateState(res.payload.affiliateStatus);
      })
      .catch((e) => {
        message.error(e.message || "Something went wrong");
      });
  };

  const handlePasswordChange = async (values) => {
    const payload = {
      currentPassword: values.currentPassword,
      newPassword: values.newPassword,
    };
    try {
      await apiService
        .post("/auth/change-password", payload)
        .then((res) => {
          message.success("Password changed successfully");
          setIsModalOpen(false);
          form.resetFields();
        })
        .catch((e) => message.error("Something went wrong"));
    } catch (error) {
      message.error(error.message || "Failed to change password");
    }
  };

  const activeLink = () => {
    const currentURL = location.pathname;
    if (currentURL === "/dashboard") {
      return "1";
    }
  };

  const copyToClipboard = (text, type) => {
    navigator.clipboard.writeText(text).then(() => {
      if (type === "affiliate") {
        setCopiedAffiliate(true);
        setTimeout(() => setCopiedAffiliate(false), 2000);
      } else if (type === "referral") {
        setCopiedReferral(true);
        setTimeout(() => setCopiedReferral(false), 2000);
      }
    });
  };

  return (
    <Layout style={{ height: "100%" }}>
      <Sider
        width={230}
        trigger={null}
        theme={"dark"}
        collapsible
        collapsed={collapsed}
        style={{
          background: "#131c2b",
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          zIndex: 100,
          transition: "width 0.3s ease-in-out",
        }}
      >
        <div
          className="demo-logo-vertical sidebar-logo"
          style={{ padding: "0px" }}
        >
          <div style={{ color: "#fff" }}>
            {collapsed ? (
              <img
                src={sidebarlogosm}
                style={{ maxWidth: "30px", marginTop: "15px" }}
              />
            ) : (
              <img src={logolg} style={{ padding: "20px 0" }} />
            )}
          </div>
        </div>
        <Menu
          mode="inline"
          theme="dark"
          defaultSelectedKeys={activeLink()}
          items={menuItems}
          style={{
            background: "#131c2b",
          }}
        />
        {!collapsed && (
          <div
            style={{
              position: "absolute",
              bottom: 20,
              width: "100%",
              textAlign: "center",
              color: "#25D366",
              fontSize: "14px",
            }}
          >
            {affiliateState == null ? (
              <Button
                onClick={() => setIsAffiliateFormOpen(true)}
                style={{
                  fontSize: "16px",
                  border: 0,
                  background: "linear-gradient(90deg, #f178e2 0%, #9b59f6 50%, #0ed2f7 100%)",
                  color: "#fff",
                  marginLeft: "20px",
                  marginBottom: "30px",
                  paddingInline: "30px",
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                Become a Affiliate
              </Button>
            ) : affiliateState == "APPROVED" ? (
              ""
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "30px",
                }}
              >
                <Button
                  onClick={() => affiliateStatus(user?._id)}
                  style={{
                    fontSize: "16px",
                    border: 0,
                    background: "linear-gradient(90deg, #f178e2 0%, #9b59f6 50%, #0ed2f7 100%)",
                    color: "#fff",
                    paddingInline: "10px",
                  }}
                >
                  Affiliate Request Pending
                </Button>
              </div>
            )}
            <Flex
              align="center"
              gap={4}
              href="https://wa.me/91xxxxxxxxxx"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "white",
                textDecoration: "none",
                paddingLeft: 20,
              }}
            >
              <WhatsAppOutlined style={{ fontSize: "20px" }} />
              <div onClick={handleWhatsAppClick} style={{ cursor: "pointer" }}>
                +971 525218176
              </div>
            </Flex>
            <Typography
              style={{
                color: "#0ed2f7",
                fontSize: 16,
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              24X7 SUPPORT AVAILABLE
            </Typography>
          </div>
        )}
      </Sider>
      <Layout
        style={{
          marginLeft: collapsed ? 80 : 230,
          transition: "margin-left 0.3s ease-in-out",
          marginTop: 64,
        }}
      >
        <Header
          theme="light"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 101,
            padding: "0PX 20PX",
            marginLeft: collapsed ? 80 : 230,
            background: "#131c2b",
            lineHeight: "63px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button
            type="text"
            icon={
              collapsed ? (
                <MenuUnfoldOutlined style={{ color: "#fff" }} />
              ) : (
                <MenuFoldOutlined style={{ color: "#fff" }} />
              )
            }
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
            }}
          />
          <Space>
            {affiliateState === "APPROVED" && (
              <div
                style={{
                  background: "rgba(255, 255, 255, 0.1)",
                  padding: "10px 16px",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "12px",
                  height: "48px",
                  marginRight: "30px",
                  border: "1px solid rgba(255,255,255,0.2)",
                }}
              >
                <span
                  style={{
                    color: "#fff",
                    fontSize: "15px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    flex: 1,
                    overflow: "hidden",
                  }}
                >
                  <strong>Affiliate Link :</strong>
                  <a
                    href={`${process.env.REACT_APP_BASE_URL}?affiliateCode=${userData?.affiliateCode}`}
                    style={{
                      color: "#4da6ff",
                      textDecoration: "none",
                      fontWeight: 500,
                      maxWidth: "200px", // set max width here
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 1,
                      overflow: "hidden",
                      fontSize: "14px",
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {`${process.env.REACT_APP_BASE_URL}?affiliateCode=${userData?.affiliateCode}`}
                  </a>
                </span>

                <Button
                  type="text"
                  icon={
                    copiedAffiliate ? (
                      <CheckOutlined style={{ color: "#52c41a" }} />
                    ) : (
                      <CopyOutlined style={{ color: "#fff" }} />
                    )
                  }
                  onClick={() =>
                    copyToClipboard(
                      `${process.env.REACT_APP_BASE_URL}?affiliateCode=${userData?.affiliateCode}`,
                      "affiliate"
                    )
                  }
                  size="middle"
                  style={{
                    borderRadius: "6px",
                    background: "rgba(255,255,255,0.15)",
                    border: "none",
                    width: "36px",
                    height: "36px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                />
              </div>
            )}
            <div
              style={{
                background: "rgba(255, 255, 255, 0.1)",
                padding: "10px 16px",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px",
                height: "48px",
                marginRight: "30px",
                border: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <span
                style={{
                  color: "#fff",
                  fontSize: "15px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  flex: 1,
                  overflow: "hidden",
                }}
              >
                <strong>Referral Link :</strong>
                <a
                  href={`${process.env.REACT_APP_BASE_URL}?refferalCode=${userData?.refferalCode}`}
                  style={{
                    color: "#4da6ff",
                    textDecoration: "none",
                    fontWeight: 500,
                    maxWidth: "200px", // ✅ set max width here
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 1,
                    overflow: "hidden",
                    fontSize: "14px",
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {`${process.env.REACT_APP_BASE_URL}?refferalCode=${userData?.refferalCode}`}
                </a>
              </span>

              <Button
                type="text"
                icon={
                  copiedReferral ? (
                    <CheckOutlined style={{ color: "#52c41a" }} />
                  ) : (
                    <CopyOutlined style={{ color: "#fff" }} />
                  )
                }
                onClick={() =>
                  copyToClipboard(
                    `${process.env.REACT_APP_BASE_URL}?refferalCode=${userData?.refferalCode}`,
                    "referral"
                  )
                }
                size="middle"
                style={{
                  borderRadius: "6px",
                  background: "rgba(255,255,255,0.15)",
                  border: "none",
                  width: "36px",
                  height: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
            </div>

            <Dropdown
              menu={{
                items,
                onClick: menuClick,
              }}
              trigger={["click"]}
            >
              <a onClick={(e) => e.preventDefault()}>
                <Space
                  style={{ color: "#fff", marginRight: "20px" }}
                  className="user-name"
                >
                  {user?.fullName}
                  <DownOutlined />
                </Space>
              </a>
            </Dropdown>
          </Space>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            background: "rgb(220 220 220 / 52%)",
            borderRadius: borderRadiusLG,
            // minHeight: "800px"
          }}
        >
          {children}
        </Content>
      </Layout>
      <Modal
        title="Change Password"
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          form.resetFields();
        }}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handlePasswordChange}>
          <Form.Item
            name="currentPassword"
            label="Current Password"
            rules={[
              { required: true, message: "Please enter your current password" },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label="New Password"
            rules={[{ required: true, message: "Please enter a new password" }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="Confirm Password"
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: "Please confirm your new password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value)
                    return Promise.resolve();
                  return Promise.reject(new Error("Passwords do not match!"));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item style={{ marginBottom: "0px" }}>
            <Button type="primary" htmlType="submit">
              Change Password
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <AffiliateForm
        isOpen={isAffiliateFormOpen}
        onClose={() => setIsAffiliateFormOpen(false)}
        createAffiliate={createAffiliate}
        userData={userData}
      />
    </Layout>
  );
};

export default connect(
  ({ login }) => ({ user: login.user, customer: login.customer }),
  { isLogin, setUserData }
)(UserLayout);
